import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "dtm-main-page-lib-sah",
    templateUrl: "./sah-subpage.component.html",
    styleUrls: ["../shared.scss", "sah-subpage.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SahSubpageComponent {}
